/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_CREATE_HEADER_COMPONENT
 * Date:         2025-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Extracted header logic from BroadcastCreatePage into a standalone component.
 * Standardized layout and actions for broadcast creation.
 *
 * File Size Check:
 * - New component
 * - Projected: ~60 lines
 * - Decision: Proceed (within 200-line limit)
 */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { downloadBroadcastUploadTemplateXLSX } from "../../../utils/broadcastTemplate";

interface BroadcastCreateHeaderProps {
  fileInputRef: React.RefObject<HTMLInputElement>;
  uploadButtonRef: React.RefObject<HTMLButtonElement>;
  handleUploadClick: () => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

const BroadcastCreateHeader: React.FC<BroadcastCreateHeaderProps> = ({
  fileInputRef,
  uploadButtonRef,
  handleUploadClick,
  handleFileChange,
}) => {
  return (
    <div className="bg-light border-top border-bottom py-3 px-3 d-flex justify-content-between align-items-center">
      <h2 className="m-0 fw-semibold">Create Broadcast</h2>
      <div className="d-flex gap-2">
        <button
          className="btn-template"
          type="button"
          onClick={downloadBroadcastUploadTemplateXLSX}
        >
          Download Template
        </button>
        <button
          ref={uploadButtonRef}
          className="btn-upload-file"
          type="button"
          onClick={handleUploadClick}
        >
          <FontAwesomeIcon icon={faArrowUp} />
          <span>Upload file</span>
        </button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv,.xlsx"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default BroadcastCreateHeader;
